module.exports = __webpack_public_path__ + "img/infoIcon.d50eae35.svg";